import { render } from "./GridActivitati.vue?vue&type=template&id=251f7b34&ts=true"
import script from "./GridActivitati.vue?vue&type=script&lang=ts"
export * from "./GridActivitati.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__